/**
 * Imperative toast bridge for non-React contexts (MobX stores, helper modules).
 * Wraps the shadcn/ui useToast infrastructure so callers don't need a hook.
 *
 * For React components, prefer useToast() directly so toasts are scoped to
 * the component tree's lifecycle.
 */
import i18n from "@/i18n";
import { toast as imperativeToast } from "@/components/ui/use-toast";
import type { TranslationKey } from "@/i18n/types";

interface ToastFromKeyOptions {
  titleKey?: TranslationKey;
  descriptionKey?: TranslationKey;
  variant?: "default" | "destructive";
  values?: Record<string, unknown>;
}

export function showToast(options: {
  title?: string;
  description?: string;
  variant?: "default" | "destructive";
}) {
  return imperativeToast({
    title: options.title,
    description: options.description,
    variant: options.variant,
  });
}

export function showToastFromKey({
  titleKey,
  descriptionKey,
  variant,
  values,
}: ToastFromKeyOptions) {
  return imperativeToast({
    title: titleKey ? (i18n.t(titleKey, values) as string) : undefined,
    description: descriptionKey
      ? (i18n.t(descriptionKey, values) as string)
      : undefined,
    variant,
  });
}

export function showErrorToast(messageKey: TranslationKey) {
  return showToastFromKey({
    titleKey: "errors.generic_title",
    descriptionKey: messageKey,
    variant: "destructive",
  });
}
